import { useMutation, useQueryClient } from '@tanstack/react-query';

import { api } from '@/lib/api/api';
import type { AgentBrokerInput } from '@/lib/api/domains/agents-brokers';
import { keys } from '@/lib/query-keys';

export function useCreateAgentBroker() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (input: AgentBrokerInput) => api.agentsBrokers.create(input),
    onSuccess: () => {
      void queryClient.invalidateQueries({
        queryKey: keys.agentsBrokers.lists(),
      });
    },
  });
}
